import zendeskApi from '@/services/plataforma/zendesk';

export default {
  actionGetScreenInformation({ commit }, enrollmentId) {
    return zendeskApi.getScreenInformation(enrollmentId)
      .then((response) => {
        commit('SET_SCREEN_INFORMATION', response.data);

        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.message);
      });
  },
  actionRegisterTicket(_, params) {
    return zendeskApi.registerZendeskTicket(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.error.message);
      });
  }
};
